export default "__VITE_ASSET__eb81ff79__"